import React from "react";
import { Route, Switch } from "react-router-dom";
//Pages

import PageLogin from "../pages/login/Login";
import PageHome from "../pages/home/index";
import PageError from "../pages/error/index";
import PageVehicleForm from "../pages/vehicle_form/index";
import PageUserForm from "../pages/user_form/index";
import PageVehicleConfirm from "../pages/vehicle_confirm/index";
import { handleLogin } from "../pages/login/LoginRedirect";

const Routes = () => (
  <Route
    render={({ location }) => (
      <Switch location={location}>
        <Route exact path="/" component={PageHome} />
        <Route exact path="/home/:vin" component={PageHome} />
        <Route exact path="/error" component={PageError} />
        <Route exact path="/login" component={PageLogin} />
        <Route exact path="/login-redirect" component={handleLogin} />
        <Route exact path="/user-form" component={PageUserForm} />
        <Route exact path="/vehicle-form" component={PageVehicleForm} />
        <Route exact path="/vehicle-confirm" component={PageVehicleConfirm} />
      </Switch>
    )}
  />
);

export default Routes;
